import {
	gsap
} from 'gsap';
// import { SplitText } from 'gsap/SplitText';

export class Animations {

	constructor() {
	}
}